<template>
  <div>
    <el-dialog :visible.sync="showLogin" :show-close="false" width="400px" :open="open" destroy-on-close>
      <div class="container">
        <div class="login-panel">
          <el-form v-if="tab == 1" ref="loginForm" class="login-form" label-position="left">
            <div class="barcode-bg" @click="changeQrLogin">
              <div class="barcode"></div>
            </div>
            <div class="qr">
              <img src="@/assets/logn/logo.png" alt="" class="qr-logo"/>
            </div>
            <div class="input-area">
              <div class="input-cell">
                <div class="input-header"> 手机号</div>
                <input v-model="mobile" type="text" placeholder="请输入手机/邮箱"/>
              </div>
              <div class="input-cell">
                <div class="input-header"> 验证码</div>
                <input v-model="captcha" type="text" placeholder="请输入验证码"/>
                <div class="captcha-btn login-btn" :class="{ 'btn-disabled': captchaStatus }"
                     v-loading="captchaLoading">
                  <span @click="getCaptcha" v-if="!captchaStatus">发送验证码</span>
                  <van-count-down @finish="captchaStatus = false" v-else :time="time">
                    <template v-slot="timeData">
                      <span class="block">{{ timeData.seconds }}</span>
                    </template>
                  </van-count-down>
                </div>
              </div>
            </div>
            <div style="display: flex;flex-flow: row;width: 100%;justify-content: center;">
              <div @click="login" class="main-btn login-btn"> 确定</div>
              <div @click="register" class="main-btn login-btn"> 注册</div>
            </div>
            <!--            <div @click="register" class="register-btn"> 没有账号？ 立即注册</div>-->
          </el-form>
          <el-form v-if="tab == -1" ref="loginForm" class="login-form" label-position="left">
            <div class="barcode-bg" @click="changeLogin">
              <div class="qrcode"></div>
            </div>
            <div class="qr">
              <img src="@/assets/logn/logo.png" alt="" class="qr-logo"/>
              <div class="qr-title">微信扫码登录</div>
              <div class="qrcode">
                <qr-code v-loading="isScan" :loading="qrCodeLoading" loadingText="扫码登录中" v-if="tab==-1"
                         :url="qrCodeUrl" :callback="initQrCode" :refresh="refreshQrCode"/>
              </div>
              <div style="display: flex;flex-flow: row;width: 100%;margin-top: -20px;justify-content: center;">
                <!--                <div @click="login" class="main-btn login-btn"> 确定</div>-->
                <div @click="register" class="main-btn login-btn"> 注册</div>
              </div>
              <!--              <div @click="register" class="register-btn"> 没有账号？ 立即注册</div>-->
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <register ref="register"></register>
  </div>
</template>

<script>
import _ from 'lodash';
import qrCode from "@/components/qr-code/index";
import {getCaptcha, scanSubscribeQrcode, scanSubscribeQrcodeResults} from "@/api/user";
import Register from '@/views/login/register.vue';

export default {
  name: "Login",
  components: {qrCode, Register},
  data() {
    return {
      showLogin: false,
      showRegister: false,
      tab: 1,
      wx_key: "",
      qrCodeLoading: false,
      isQrCode: false,
      qrCodeUrl: "",
      activeName: "login",
      mobile: "",
      captcha: "",
      time: 60 * 1000,
      captchaStatus: false,
      redirect: "",
      otherQuery: {},
      captchaLoading: false,
      unionid: "",
      isScan: false,
    };
  },
  computed: {},
  watch: {
    showLogin(val) {
      this.isScan = false
      if (val) this.tab = 1
    },
    $route: {
      handler: function (route) {
        if (route.path == "/login") {
          this.showLogin = true;
        }
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {

  },
  methods: {
    showlogin() {
      this.showLogin = true;
    },
    changeQrLogin() {
      this.tab = -1;
      this.refreshQrCode();
    },
    changeLogin() {
      this.tab = 1;
      this.isQrCode = false;
    },
    register() {
      this.showLogin = false
      this.$refs["register"].unionid = this.unionid
      this.$refs['register'].showRegisterDialog()
    },
    async refreshQrCode() {
      const {data: {uuid, url, last_time}} = await scanSubscribeQrcode() || {};
      this.wx_key = uuid;
      this.qrCodeUrl = url;
      this.isQrCode = true;
      const that = this;
      await this.scanSubscribeQrcodeResults(last_time, async () => {
        const {data: {status, token = "", unionid = ""}, code} = await scanSubscribeQrcodeResults({
          uuid: that.wx_key,
          last_time
        });
        if (status < 0) { // 二维码过期
          console.log("二维码过期");
          that.refreshQrCode();
          return true;
        }
        if (status == 0) { // 还未扫码
          console.log("还未扫码");
          return false;
        }
        if (status == 1) { // 用户已扫码
          console.log("用户已扫码");
          that.isScan = true
          return false;
        }
        if (status == 2) { // 用户已经绑定微信返回token登录
          console.log("用户已经绑定微信返回token登录");
          this.$store.dispatch("user/setToken", token).then(() => {
            that.isScan = false
            that.showLogin = false
            location.reload()
            that.$router.replace({path: that.redirect || this.$route.path, query: this.otherQuery,});
          });
          return true;
        }
        if (status == 3) { // 用户未绑定微信需要弹出绑定或注册选项
          that.unionid = unionid;
          that.isScan = false
          that.$message({
            message: "当前微信未绑定账号，请使用注册手机号绑定微信扫码登录或注册新账号",
            type: "warning",
            offset: 200
          });
          // alert("当前微信未绑定账号，请使用注册手机号绑定微信扫码登录或注册新账号");
          that.tab = 1;
          return true;
        }
        return false;
      });
    },
    async initQrCode(dataUrl, id) {
      console.log(dataUrl, id);
    },
    async scanSubscribeQrcodeResults(last_time, callback = null, error = null) {
      const sleep = (time) => new Promise((resolve) => setTimeout(resolve, time));
      while (this.tab == -1 && this.showLogin) {
        const startDate = parseInt(new Date().getTime() / 1000);
        if (startDate > last_time) { //二维码过期
          if (typeof error == "function") error();
          return;
        }
        if (typeof callback == "function" && await callback()) { // 回调函数返回 true 结束轮询
          return;
        }
        const endDate = parseInt(new Date().getTime() / 1000);
        let second = _.subtract(endDate, startDate);
        second = 3000 - second;
        if (second > 0) await sleep(3000);
      }
    },
    login() {
      if (this.formCheck()) {
        this.$store.dispatch("user/login", {
          mobile: this.mobile,
          captcha: this.captcha,
          unionid: this.unionid,
        }).then(() => {
          this.$router.push({path: this.redirect || this.$route.path, query: this.otherQuery,})
          this.showLogin = false
          location.reload()
        });
      }
    },
    getCaptcha() {
      this.captchaLoading = true;
      getCaptcha({mobile: this.mobile}).then((res) => {
        this.captchaLoading = false;
        if (res.code == 200) {
          this.captchaStatus = true;
        }
      });
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur != "redirect") {
          [cur] = query[cur];
        }
        return acc;
      }, {});
    },
    formCheck() {
      if (!this.mobile) {
        this.$message({message: "请填写手机", type: "error",});
        return false;
      }
      if (!this.captcha) {
        this.$message({message: "请填写验证码", type: "error",});
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        this.$message({message: "手机号格式不正确", type: "error",});
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";

.barcode-bg {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 80px;
  height: 88px;
  //background-image: url("../../assets/logn/barcode-bg.png");
  background-size: cover;

  .barcode {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 49px;
    height: 48px;
    background-image: url("../../assets/logn/barcode.png");
    background-size: cover;
  }

  .qrcode {
    position: absolute;
    top: -5px;
    right: -6px;
    width: 50px;
    height: 39px;
    background-image: url("../../assets/logn/barcode1.png");
    background-size: cover;
  }
}
.login-btn {
  cursor: pointer;
}
</style>
